import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getBankBenefits } from '../../../../../redux/actions/BankActions';
import ProfileTitle from '../../../../layout/mobile/profile/ProfileTitle';
import SilverStar from '../../../../../assets/silver_star.svg';
import GoldenStar from '../../../../../assets/gold_star.svg';
import NoBenefits from './NoBenefits/NoBenefits';
import BenefitsList from './BenefitsList';
import BenefitsIcon from '../../../../common/icons/BenefitsIcon';

const Benefits = ({ ...props }) => {
  const { mobile, points } = props;
  const dispatch = useDispatch();
  const { benefits } = useSelector((state) => state.bankReducer);
  const { category } = useSelector((state) => state.loyaltyReducer);
  const [openGoldenModal, setOpenGoldenModal] = useState(false);

  const imageSelector = (innerCategory) =>
    innerCategory === 'silver' ? SilverStar : GoldenStar;

  useEffect(() => {
    dispatch(getBankBenefits());
  }, []);

  return (
    <React.Fragment>
      <ProfileTitle
        title={<strong>Beneficios</strong>}
        subtitle="Aquí podrás ver los beneficios que tienes según tus Ripley Puntos Go acumulados."
        mobile={mobile}
        icon={<BenefitsIcon size="30px" color="#6A148E" />}
      />
      {category !== 'silver' && category !== 'gold' && (
        <NoBenefits mobile={mobile} benefits={benefits} points={points} />
      )}
      {(category === 'silver' || category === 'gold') && (
        <BenefitsList
          benefits={benefits}
          type={category}
          mobile={mobile}
          image={imageSelector(category)}
          onClick={() => setOpenGoldenModal(!openGoldenModal)}
          open={openGoldenModal}
          onClose={() => setOpenGoldenModal(false)}
          points={points}
        />
      )}
    </React.Fragment>
  );
};

Benefits.propTypes = {
  mobile: PropTypes.bool,
  points: PropTypes.number,
};

export default Benefits;
